if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.dialog = this.querySelector('.js-cart-terms-dialog');
      if (!this.dialog) {
        throw new Error('cart-terms: missing ".js-cart-terms-dialog". Render the "cart-terms-dialog" snippet inside <cart-terms>.');
      }

      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);

      this.dialog.querySelector('.js-cart-terms-accept').addEventListener('click', this.handleAccept.bind(this));
      this.dialog.querySelector('.js-cart-terms-decline').addEventListener('click', () => this.dialog.close());

      // Force a choice: Escape must not dismiss the dialog.
      this.dialog.addEventListener('cancel', (evt) => evt.preventDefault());
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit. Opens the terms dialog if the terms are not accepted.
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (this.cartTermsCheckbox.checked) return;

      evt.preventDefault();
      this.submitter = evt.submitter;
      this.dialog.showModal();
    }

    /**
     * Accepts the terms and continues to checkout with the original submit button.
     */
    handleAccept() {
      this.cartTermsCheckbox.checked = true;
      this.dialog.close();
      this.form.requestSubmit(this.submitter);
    }
  }
  customElements.define('cart-terms', CartTerms);
}
